import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SEO = ({ title, description, keywords, url }) => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const siteTitle = "PrimeForce Services W.L.L.";
    const defaultDescription = "PrimeForce Services delivers top-tier professional cleaning and maintenance services. Strength in Service, Excellence in Action.";

    // Determine the full title
    const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;

    return (
        <Helmet>
            <html lang={currentLang} dir={currentLang === 'ar' ? 'rtl' : 'ltr'} />
            <title>{fullTitle}</title>
            <meta name="description" content={description || defaultDescription} />
            {keywords && <meta name="keywords" content={keywords} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            {url && <meta property="og:url" content={url} />}

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description || defaultDescription} />

            <link rel="canonical" href={url || window.location.href} />
        </Helmet>
    );
};

export default SEO;
